var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d4bcb73c407e018b60b645946cc3ad2b45049260"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["watershed-marketing@watershed-0y"]={id:"d4bcb73c407e018b60b645946cc3ad2b45049260"};
      